<template>
  <div class="pay-middle">
    <div class="btn">
      <p @click="otherWay">其他方式支付</p>
      <p class="p1" @click="getOrder">已完成支付</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PayMiddle",
  data() {
    return {
      query: this.$route.query,
      timer: null
    };
  },
  methods: {
    /**
     * 校验是否支付完成
     * @param {Number} type  1异常弹窗返回Pay  2不返回继续校验
     */
    async checkPay() {
      let data = await this.$http.post(`/api/pay/sync/notify`, {
        payment_number: this.query.payment_number,
        pay_type: this.query.pay_type
      });
      if (data.code) {
        return;
      } else {
        if (data.group_id) {
          this.$router.replace({
            name: "GroupDetail",
            query: {
              group_id: data.group_id
            }
          });
        } else {
          this.$pub.ToOrder(data.shop_type);
        }
      }
    },
    /**
     * 已支付完成
     */
    async getOrder() {
      let order = await this.$http.post(`/api/app/myOrder/detail`, {
        order_id: this.query.order_id
      });
      let query = { order_id: this.query.order_id };
      if (order.group_id) {
        query.is_spell = 1;
      } else {
        switch (order.shop_type) {
          case 1:
            query.order_type = 1;
            break;
          case 14:
            query.order_type = 3;
            break;
          case 12:
            query.order_type = 4;
            break;
          case 15:
              query.order_type = 5;
          break;
          case 16:
              query.order_type = 6;
          break;
          default:
            query.order_type = 2;
            break;
        }
      }

      console.log( query );
      this.$router.replace({
        name: "OrderDetail",
        query: query
      });
    },
    otherWay() {
      this.$router.replace({
        name: "Pay",
        query: { order_id: this.query.order_id }
      });
    },
    Timer() {
      this.timer = setInterval(() => {
        this.checkPay();
      }, 1000);
    }
  },
  async created() {
    this.Timer();
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="scss" scoped>
.pay-middle {
  width: 100vw;
  height: 100vh;
  background: url("~@/assets/images/group/loading.gif") no-repeat center center;
  background-size: 120% 120%;
  position: relative;
  .btn {
    position: absolute;
    left: 0;
    right: 0;
    top: 60%;
    display: flex;
    justify-content: center;
    p {
      width: 236px;
      height: 66px;
      border-radius: 34px;
      border: 2px solid rgba(217, 217, 217, 1);
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(140, 140, 140, 1);
      line-height: 66px;
      text-align: center;
      margin: 0 20px;
    }
    .p1 {
      border: 2px solid $theme_color;
      color: $theme_color;
    }
  }
}
</style>
